// Small reusable building blocks for admin modals.
export function Section({ title, children }) {
  return (
    <section>
      <h3 className="text-[10px] uppercase tracking-widest font-bold text-[var(--ink-soft)] mb-2">{title}</h3>
      {children}
    </section>
  );
}

export function Field({ label, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="block text-[10px] uppercase tracking-widest font-bold text-[var(--ink-soft)] mb-1">{label}</label>
      <input
        type={type}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 rounded-xl border border-[var(--line)] text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
        data-testid={testid}
      />
    </div>
  );
}
